import { useQuery } from '@apollo/client';
import { GET_DEFAULT_MEMBER_FIELD_SCHEMAS_QUERY } from '../queries/GetDefaultMemberFieldSchemasQuery';
import { GetDefaultMemberFieldSchemasQuery } from '../queries/types/GetDefaultMemberFieldSchemasQuery';

export const useGetDefaultMemberFieldSchemasQuery = () => {
  const { data, loading, error } = useQuery<GetDefaultMemberFieldSchemasQuery>(GET_DEFAULT_MEMBER_FIELD_SCHEMAS_QUERY);

  return {
    defaultMemberFieldSchemas: data?.publicDefaultMemberFieldSchemas,
    isDefaultMemberFieldSchemasLoading: loading,
    defaultMemberFieldSchemasError: error,
  };
};
